var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAnonymousClient, useFunctionClient } from '@juvare/platform-sdk-react/ui/hooks';
export function useTypedAnonymousPlatformFunctionCM(functionDef, app, entity) {
    const anonymousClient = useAnonymousClient(app, entity);
    return (request) => __awaiter(this, void 0, void 0, function* () {
        const response = yield anonymousClient.executeFunction({
            functionName: functionDef.name,
            params: functionDef.requestSchema.parse(request),
        });
        return yield functionDef.responseSchema.parse(response.result);
    });
}
export function useTypedPlatformFunctionCM(functionDef, baseUrl, tokenProvider) {
    const functionClient = useFunctionClient(baseUrl, tokenProvider);
    return (request) => __awaiter(this, void 0, void 0, function* () {
        const response = yield functionClient.executeFunction({
            functionName: functionDef.name,
            params: functionDef.requestSchema.parse(request),
        });
        return yield functionDef.responseSchema.parse(response.result);
    });
}
